module.exports = "/images/flags.png?416250f60d785a2e02f17e054d2e4e44";


//////////////////
// WEBPACK FOOTER
// ./public/img/flags.png
// module id = Zufj
// module chunks = 5